import compactFP from 'lodash/fp/compact';
import flowFP from 'lodash/fp/flow';
import joinFP from 'lodash/fp/join';
import type { BrokerContact as BrokerContactType } from '@/graphql/common/types';

const joinAddress = (address: Array<string | undefined>, separator = ', ') =>
  flowFP(compactFP, joinFP(separator))(address);

export const getFullAddress = (address: BrokerContactType['address']) => {
  const first = joinAddress([address?.street, address?.number]);
  const second = joinAddress([address?.city, address?.state]);
  return joinAddress([first, second], ' - ');
};
